export default "__VITE_ASSET__ruE7kUGu__"